import { precompileTemplate } from "@ember/template-compilation";
export default precompileTemplate("{{component @composer.config.customStylesConfig.colorPickerComponent value=this.selectedColor setColor=this.onChangeColor}}", {
  moduleName: "@intercom/embercom-prosemirror-composer/components/utils/color-picker.hbs"
});